import React, { useEffect, useState } from 'react';
import { X, Zap } from 'lucide-react';
export function OfferBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState({
    minutes: 12,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#8B9F3A] shadow-sm" data-id="element-244">
      <div className="max-w-6xl mx-auto px-4 py-2" data-id="element-245">
        <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-246">
          {/* Offer text */}
          <div className="flex items-center gap-1.5 text-white" data-id="element-247">
            <Zap className="w-3.5 h-3.5 text-yellow-300 fill-yellow-300" data-id="element-248" />
            <span className="font-bold text-xs md:text-sm uppercase tracking-wide" data-id="element-249">
              Oferta Flash: 30 Cenas + 3 Bonos
            </span>
          </div>

          {/* Timer */}
          <div className="bg-white text-[#2E2E2E] px-2 py-0.5 rounded font-mono font-bold text-xs" data-id="element-250">
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </div>

          {/* CTA Button */}
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-white text-[#2E2E2E] px-3 py-1 rounded font-bold text-xs uppercase tracking-wide hover:bg-gray-100 transition-colors" data-id="element-251">
            Aprovechar
          </button>

          {/* Close button */}
          <button onClick={() => setIsVisible(false)} className="absolute right-2 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors p-0.5" aria-label="Cerrar banner" data-id="element-252">
            <X className="w-4 h-4" data-id="element-253" />
          </button>
        </div>
      </div>
    </div>;
}